/* unplugin-vue-components disabled */import script from "./InvoiceRecordPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceRecordPopup.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceRecordPopup.vue?vue&type=style&index=0&id=2aa9acaa&lang=scss"

const __exports__ = script;

export default __exports__